import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isDate.js
// module id = 490
// module chunks = 8